<p>spotlight-footer works!</p>
